module.exports = __webpack_public_path__ + "img/m_bigbanner1.c1615388.jpg";